import { render } from "./BalLoadingIcon.vue?vue&type=template&id=5c9944f3&scoped=true"
import script from "./BalLoadingIcon.vue?vue&type=script&lang=js"
export * from "./BalLoadingIcon.vue?vue&type=script&lang=js"

import "./BalLoadingIcon.vue?vue&type=style&index=0&id=5c9944f3&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9944f3"]])

export default __exports__